import { Component } from '@angular/core'
import { NavParams, ViewController, ToastController, LoadingController, AlertController } from 'ionic-angular';
import { DriverServiceProvider } from '../../../providers/dvm/driver-service';
@Component({
    templateUrl: 'ecommerce.modal.html',
    providers: [DriverServiceProvider]
})
export class ChangeDriverPage {
    loading: any;
    drivers: any;
    ecommerceId: any;
    checkedList = [];
    constructor(params: NavParams, private viewCtrl: ViewController, private alertCtrl: AlertController, private provider: DriverServiceProvider, private toastCtrl: ToastController, private loadingCtrl: LoadingController) {
        this.ecommerceId = params.data.ecommerceId;
        // get driver
        this.showLoading();
        document.addEventListener('backbutton', () => {
            this.dismiss(false);
          }, false);
        this.provider.load_driver_list().then(data => {
            this.loadingDismiss();
            let resp: any = data;
            this.drivers = resp.data;
            console.log("drivers:" + this.drivers);
        })
    }

    dismiss(isRefresh) {
        this.checkedList = [];
        this.viewCtrl.dismiss(isRefresh);
    }

    checked(driverId, event) {
        if (event.checked) {
            this.checkedList.push(driverId);
        }
        else {
            this.checkedList.splice(this.checkedList.indexOf(driverId), 1);
        }
        console.log("checked:" + this.checkedList);
    }

    change() {
        if (this.checkedList.length == 0) {
            this.showAlert('Warm tips', 'Please select at least one');
            return;
        }
        this.showLoading();
        this.provider.assignDriverToEcommerce(this.ecommerceId, this.checkedList).then(data => {
            let resp: any = data;
            this.loadingDismiss();
            if (resp.code == '1001') {
                this.dismiss(true);
            }
            else {
                this.toastCtrl.create({
                    message: resp.message,
                    duration: 3000
                }).present();
            }
        })
    }

    showAlert(title, text) {
        let alert = this.alertCtrl.create({
            title: title,
            subTitle: text,
            buttons: [{
                text: "Ok"
            }]
        });
        alert.present();
    }

    showLoading() {
        this.loading = this.loadingCtrl.create({
            content: "Please Wait..."
        })
        this.loading.present();
    }

    loadingDismiss() {
        if (this.loading != null) {
            this.loading.dismiss();
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/backoffice/ecomerce/ecomerce.modal.ts